import { Table } from '@statsbomb/kitbag-components';
import { useTranslation } from 'react-i18next';

export const TeamGameWatchHeaderCell = () => {
  const { t } = useTranslation('games');

  return (
    <Table.HeaderCell textAlign="left" size="regular">
      <span>{t('gameVideo')}</span>
    </Table.HeaderCell>
  );
};
